// extracted by mini-css-extract-plugin
export default {"container":"DialogCancelWlistConfirm_container__Q0P+k","icon":"DialogCancelWlistConfirm_icon__qPeXM"};